<template>
    <div>
        <v-alert type="warning" color="orange" v-if="code === 'SAVING' || code === 'SAVING_DRAFT'">
            Le formulaire est en cours d'enregistrement. Merci de réessayer plus tard.
        </v-alert>

        <v-alert type="warning" color="orange" v-if="code === 'NOT_FOUND'">
            Le formulaire n'existe pas.
        </v-alert>

        <v-alert type="warning" color="orange" v-if="code === 'ARCHIVED'">
            Le formulaire est cloturé.<br>
            Si vous pensez qu'il s'agit d'une erreur, merci de contacter votre partenaire.
        </v-alert>

        <v-alert type="warning" color="orange" v-if="code === 'ANSWERED'">
            Vous avez déjà répondu à ce formulaire.
        </v-alert>

        <v-alert type="warning" color="orange" v-if="code === 'DELETED'">
            Le formulaire n'est plus accessible.<br>
            Merci de contacter l'office du tourisme pour plus d'informations.
        </v-alert>
    </div>
</template>

<script>
export default {
    name: "CmajFormError",
    props: ['code']
}
</script>